export default "__VITE_ASSET__Cfar8inf__"